// 施工许可证
import http from "@/promise/http"
const CONTROLLER_NAME = "/builderLicenses/"

// 获取施工项目列表
export const postListPage = (pageNum, numPerPage, params) => {
  return http.post(CONTROLLER_NAME.concat("listPage"), {
    pageNum: pageNum,
    numPerPage: numPerPage,
    condition: params
  });
};

//通过id获取详细信息 
export const postDetail = id => {
    return http.post(CONTROLLER_NAME.concat("detail"), id);
  };

  // 新增或更新信息
export const postSubmitForm = infoForm => {
  return http.post(CONTROLLER_NAME.concat('saveOrUpdate'), infoForm)
}

// 删除单位
export const postRemove = ids => {
  return http.post(CONTROLLER_NAME.concat("remove"), ids);
};